
import StepBar from "@/components/stepBar/StepBar.vue";
import { Inscription, InscriptionStatus } from "@/types/interface";
import { Payment, PaymentStatus } from "@/types/payment";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    StepBar,
  },
  data() {
    return {
      wantToDonate: null as boolean | null,
      otherDonationAmount: false,
      loading: false,
      isNecessaryToUpdatePayment: false,
      donationAmount: 0,
      errorMsg: "",
      payment: {} as Payment,
    };
  },
  computed: {
    inscription(): Inscription {
      return this.$store.getters["user/getMe"].inscriptions.find(
        (inscription: Inscription) =>
          inscription.edition.id ===
            this.$store.getters["edition/getEditionId"] &&
          inscription.status !== InscriptionStatus.CANCELLED
      );
    },
    paymentDonationAmount(): number {
      return this.payment.donationAmount;
    },
  },
  methods: {
    passPayment() {
      this.$router.push({ name: "Home" });
    },
    async getHelloassoRedirectLink() {
      this.loading = true;
      const response = await axios.post(
        `/payments/${this.payment.id}/initiate`,
        {
          donationAmount: this.wantToDonate ? this.payment.donationAmount : 0,
        }
      );
      if (response.status !== 200)
        return (this.errorMsg =
          response.data.errors?.at(0).message ?? "Une erreur est survenue");

      if (response.data?.status === PaymentStatus.VALIDATED)
        return this.passPayment();

      this.payment = response.data;
      this.loading = false;
    },
    centimesToEuro(centimes: number) {
      return centimes / 100;
    },
    euroToCentimes(euro: number) {
      return euro * 100;
    },
    computeTotalAmount() {
      return this.centimesToEuro(
        this.payment.raceAmount +
          (this.wantToDonate ? this.payment.donationAmount : 0)
      );
    },
    async createPayment() {
      const response = await axios.post("/payments", {
        inscriptionId: this.inscription.id,
      });
      if (response.status === 409) {
        this.getMyPayment();
        return;
      }
      if (response.status !== 200)
        return (this.errorMsg = "Une erreur est survenue");
      this.payment = response.data;
    },
    async getMyPayment() {
      const response = await axios.get("/payments/me");
      if (response.status !== 200)
        return (this.errorMsg = "Une erreur est survenue");
      this.payment = response.data.find(
        (payment: Payment) =>
          payment.inscription.edition.id ===
          this.$store.getters["edition/getEditionId"]
      );
      this.checkIfPaymentLinkIsExpired();
    },
    async updateMyPaymentWithNewDonationAmount() {
      this.loading = true;
      if(this.payment.donationAmount < 0 ) {
        this.errorMsg = "Le montant du don ne peut pas être négatif.";
        this.loading = false;
        return;
      }
      const response = await axios.patch(
        `/payments/${this.payment.id}/update`,
        {
          donationAmount: this.wantToDonate ? Math.max(this.payment.donationAmount, 0) : 0,
        }
      );
      if (response.status !== 200) {
        this.errorMsg =
          response.data.errors?.at(0).message ?? "Une erreur est survenue";
        this.loading = false;
        return;
      }
      if (response.status === 200) this.payment = response.data;
      this.isNecessaryToUpdatePayment = false;
      this.donationAmount = this.payment.donationAmount;
      this.loading = false;
    },
    checkIfPaymentLinkIsExpired() {
      if (this.payment.helloassoCheckoutIntentUrl === null) return;
      const expirationDate = new Date(this.payment.helloassoCheckoutExpiresAt);
      const now = new Date();
      if (now > expirationDate) this.isNecessaryToUpdatePayment = true;
    },
  },
  watch: {
    wantToDonate(newValue: boolean, oldValue: boolean) {
      if (oldValue === null) return;
      this.isNecessaryToUpdatePayment = true;
      if (newValue) {
        this.payment.donationAmount = this.donationAmount;
        return;
      }
      this.payment.donationAmount = 0;
    },
    paymentDonationAmount(newValue: number, oldValue: number) {
      if (oldValue === undefined) return;
      if (oldValue === newValue) return;
      this.isNecessaryToUpdatePayment = true;
    },
  },
  async mounted() {
    if (this.$route.query.token && this.$route.query?.donationAmount) {
      await this.getMyPayment();
      this.payment.donationAmount = parseInt(
        this.$route.query.donationAmount as string
      );
      this.wantToDonate = true;
      this.isNecessaryToUpdatePayment = false;
      this.donationAmount = this.payment.donationAmount;
      return;
    }
    await this.createPayment();
  },
});
